import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessAdsService } from '@app/services/BusinessAds/businessAds.service';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { CategoryService } from '@app/services/Category/category.service';
import { ProductService } from '@app/services/Product/product.service';
import Swiper from 'swiper';
import { SearchListComponent } from '../search/search-list/search-list.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment.prod';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  active = 1;
  categories: any;
  productList: any;
  businessList: any;
  businessAds:any;
  serverUrl:any;
  serverImgUrl:any;
  
  findBusiness!: FormGroup
  findProduct!: FormGroup
  findAny!: FormGroup

  @Input() searchList!: SearchListComponent;

  constructor(
    private router: Router,
    private businessService: BusinessDetailsService,
    private productService: ProductService,
    private adsService: BusinessAdsService,
    private categoryService: CategoryService,
  ) { 

    this.findBusiness = new FormGroup({
      name: new FormControl('null', [Validators.required]),
      location: new FormControl(null, [Validators.required]),
      category: new FormControl(null, [Validators.required])
    });

    this.findProduct = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      location: new FormControl(null, [Validators.required]),
      category: new FormControl(null, [Validators.required])
    });
    
    this.findAny = new FormGroup({
      name: new FormControl(null, [Validators.required])
    });
  }

  ngOnInit() {
    this.serverUrl =  environment.API_URL;
    this.serverImgUrl = environment.IMG_URL;

    this.swiper();
    this.getProducts();
    this.getBusinessList();
    this.getBusinessAds(); 
    this.categoryList();
  }

  filterCriteria = {
    name: null,
    category: null,
    location: null
  };

  onSubmitFindAny() {
    if (this.findAny.invalid) {
      Swal.fire("Please fill out the search fields.");
      return;
    }
    this.router.navigate(['/search', this.filterCriteria.name]);
  }

  onSubmitBusiness() {
    if (this.findBusiness.invalid) {
      Swal.fire("Please fill out the search fields.");
      return;
    }
    this.router.navigate(['/search', 'b', this.filterCriteria.name,  this.filterCriteria.location, this.filterCriteria.category]);
  }

  onSubmitProduct() {
    if (this.findProduct.invalid) {
      Swal.fire("Please fill out the search fields.");
      return;
    }
    this.router.navigate(['/search', 'p', this.filterCriteria.name,  this.filterCriteria.location, this.filterCriteria.category]);
  }

  //Swiper
  swiper() {
    new Swiper(".mySwiper_product", {
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 2,
        },
        900: {
          slidesPerView: 3,
          slidesPerGroup: 2,
        },
        769: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        500: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        350: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    new Swiper(".mySwiper_photo", {
      spaceBetween: 30,
      effect: "fade",
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }); 
    new Swiper(".mySwiper_ads", {
      slidesPerView: 3,
      spaceBetween: 20,
      freeMode: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 2,
        },
        900: {
          slidesPerView: 3,
          slidesPerGroup: 2,
        },
        769: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        500: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        350: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  // Get all products
  getProducts(): void {
    this.productService.getTopSellerProducts().subscribe({
      next: (response:any) => {
        this.productList = response.data; 
      }
    }
    );
  }
  
  // Get all business
  getBusinessList(): void {
    this.businessService.getTop8BusinessInfo().subscribe({
      next: (response:any) => {
        this.businessList = response.data;
      }
    }
    );
  }

  state:any; x:any
  // Get all business
  getBusinessAds(): void {
    this.adsService.getTop8BusinessAds().subscribe({
      next: (response:any) => {
        this.businessAds = response.data;
          // if (response.data != null && response.data.length > 0) {
          //   for (var i = 0; i < response.data.length; i++) {
          //       this.state =  State.getStatesOfCountry(response.data[i].adsCountry).map(state => ({
          //       id: state.isoCode,
          //       name: `${state.name}`
          //     }))
              
          //     for (var i = 0; i < this.state.length; i++) {
          //       if (this.state[i].id === response.data[i].adsState) {
          //         this.businessAds.data[i].stateName = this.state[i].name;
          //         break;
          //       }
          //       console.log(this.businessAds);
          //       // if(this.state[i].id == response.data.adsState)
          //       // {
          //       //   response.data[i].stateName = this.state[i].name;
          //       //   //this.businessAds[i].stateName = this.state[i].name;
          //       //   this.businessAds = response.data;
          //       // }
          //     }
          //     }
          // }
        }
      }
    );
  }

  categoryList() {
    this.categoryService.getAll().subscribe({
      next: (response: any) => {
        this.categories = response.data.map((item: any) => {
          return { name: item.CategoryName, id: item.CategoryInfoId };
        });
      }
    });
  }

  // Set name for SEO URL 
  getHyphenatedString(limitedTitle :any) {
    let hyphenatedString = limitedTitle
      .replaceAll(" ", "-")
      .toLowerCase();
    return hyphenatedString;
  }
}
